import { Empty, List, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import './CommentList.less'
import PropTypes from 'prop-types'

const { Text } = Typography

const formatDate = date => {
  if (!date) return '—'

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    hour: '2-digit',
    hour12: false,
    minute: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date))
}

const CommentList = ({ comments = [] }) => {
  const { t } = useTranslation()

  if (!comments.length) {
    return (
      <Empty
        description={t('deviceManagement.commentList.noComments')}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    )
  }

  return (
    <List
      bordered
      dataSource={comments}
      size="small"
      renderItem={({ remarks, createdAt }) => (
        <List.Item className="cm-commentListItem">
          <Text>{remarks}</Text>
          <Text className="cm-commentTimestamp" type="secondary">
            {formatDate(createdAt)}
          </Text>
        </List.Item>
      )}
    />
  )
}

CommentList.propTypes = {
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string,
      remarks: PropTypes.string,
    })
  ),
}

export default CommentList
